/**
 * client.ts
 *
 * Utilities related to enabling application context on the client.
 *
 * This file is currently duplicated in the following packages:
 *
 * - packages/ud-api/src/app-context.ts
 * - packages/react-header/src/external/app-context.ts
 *
 * This is to avoid coupling between legacy componennts and this package.
 *
 * TODO: create an `AppContextProvider` package and move this code there
 * and send dependencies to that package
 */

// Define a constant for the global variable to name on the client to handoff app context.
export const APP_CONTEXT_VAR_NAME = '__UDMY_APP_CONTEXT';
export const APP_CONTEXT_VAR_PRESENT = '__UDMY_APP_CONTEXT_PRESENT';
export const APP_CONTEXT_PRESENT_SCRIPT = `window.${APP_CONTEXT_VAR_PRESENT} = true;`;

/**
 * Application Context Data Interface
 *
 * This is the interface for the application context data that is resolved in this file.
 * This interface should evolve over time as we migrate our data resolution patterns
 * to Udemy Frontends
 */

/**
 * isAppContextOnClientSupported()
 *
 * Application that returns true if application context is expected to be written to the global scope.
 *
 * if (isAppContextOnClientSupported()) {
 *     const appContext = await getClientAppContext();
 * } else {
 *     // Fallback to legacy fetch
 *     appContext = await fetchCommonAppData();
 * }
 *
 */
export function isAppContextOnClientSupported() {
  if (global.window && global.window[APP_CONTEXT_VAR_PRESENT]) {
    return true;
  }
}

/**
 * getClientAppContext()
 *
 * This function is meant to be only executed on the client browser.  It's responsible
 * reading the app context from `window[APP_CONTEXT_VAR_NAME]` that is set by
 * a script tag defined in the <head /> of the document.  This massively optimizes the priority
 * of all the requests that are defined here.
 *
 */
export async function getClientAppContext() {
  if (typeof window === 'undefined') {
    throw new Error('Cannot use `getClientAppContext()` server-side');
  }
  return new Promise(resolve => {
    function resolvePageContext() {
      const APP_CONTEXT = window[APP_CONTEXT_VAR_NAME];
      if (APP_CONTEXT) {
        resolve(APP_CONTEXT);
      } else {
        setTimeout(resolvePageContext, 100);
      }
    }
    resolvePageContext();
  });
}
//# sourceMappingURL=client.js.map